import { registerPlugin } from '@capacitor/core';

export interface WolPluginInterface {
  send(options: { macAddress: string; ipAddress: string }): Promise<{ success: boolean; error?: string }>;
}

export const Wol = registerPlugin<WolPluginInterface>('Wol');
